import { render, staticRenderFns } from "./RevisionsList.vue?vue&type=template&id=6bd90a07&"
import script from "./RevisionsList.vue?vue&type=script&lang=js&"
export * from "./RevisionsList.vue?vue&type=script&lang=js&"
import style0 from "./RevisionsList.vue?vue&type=style&index=0&id=6bd90a07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports